import { CircularProgress, formLabelClasses } from "@mui/material";
import { getElements, subscribe } from "../bridge/bridgeManager";
import i18n, { initializeTranslations } from "./common/Locale/TranslationProvider";
import { useEffect, useState, useSyncExternalStore } from "react";
import { GlobalAngularEventListener } from "./GlobalAngularEventListener";
import { I18nextProvider } from "react-i18next";
import { ThemeProvider } from "@emotion/react";
import { angularEvents } from "../bridge/angularEvents";
import { createPortal } from "react-dom";
import { createRoot } from "react-dom/client";
import { getExternalImportFiles } from "./product/import/ProductImportRepository";
import { reactEvents } from "../bridge/reactEvents";
import { theme } from "./common/Theme";

function Root() {

  const [loading, setLoading] = useState<Boolean>(false);

  useEffect(() => {
    const unsub = angularEvents.userIsAuthenticated.subscribe(async () => {
      setLoading(true);
      await initializeTranslations();
      setLoading(false);
    });

    return () => {
      unsub();
    };
  }, []);

  return (
    <div>
    {
      loading ?
        <div style={{position: 'absolute', left: '50%', top: '50%'}}>
          <CircularProgress color="primary"/>
        </div> :
      <I18nextProvider i18n={i18n} defaultNS={'translations'}>
        <ThemeProvider theme={theme}>
          <GlobalAngularEventListener>
            <BridgeElements />
          </GlobalAngularEventListener>
        </ThemeProvider>
      </I18nextProvider>
    }
    </div>
  );
}

function BridgeElements() {
  const elements = useSyncExternalStore(subscribe, getElements);

  return <>{elements.map((e) => createPortal(e.element, e.container))}</>;
}

export function renderReactRoot(container: Element) {
  const root = createRoot(container);
  root.render(<Root />);
}

